import { Dialog } from "@dash/dialog";
import { Button } from "@dash/form";
import { Theme, useTheme } from "@emotion/react";
import React from "react";
import { MdErrorOutline, MdOutlineWarningAmber } from "react-icons/md";

export type DiffSyncExecutionFailure = {
  kind: "diffsOutOfDate" | "error";
  title: string;
  message: React.ReactNode;
};

export const ExecutionFailureDialog = (props: { failure: DiffSyncExecutionFailure; onClose: () => void }) => {
  const theme = useTheme();
  const style = getFailureStyle(theme, props.failure.kind);

  return (
    <Dialog
      header={props.failure.title}
      placement="center"
      onClose={props.onClose}
      contentCss={{ width: "min(100%, 30rem)" }}
      footer={
        <div css={{ display: "flex", gap: "0.5rem", marginLeft: "auto" }}>
          <Button onClick={props.onClose}>OK</Button>
        </div>
      }
    >
      <div
        css={{
          display: "flex",
          gap: "0.75rem",
          padding: "0.75rem",
          border: `1px solid ${style.border}`,
          borderRadius: theme.smallBorderRadius,
          background: style.background,
          color: style.color,
        }}
      >
        <div css={{ flexShrink: 0 }}>{style.icon}</div>
        <p css={{ margin: 0, lineHeight: 1.4 }}>{props.failure.message}</p>
      </div>
    </Dialog>
  );
};

const getFailureStyle = (
  theme: Theme,
  kind: DiffSyncExecutionFailure["kind"],
): {
  background: string;
  border: string;
  color: string;
  icon: React.ReactNode;
} => {
  if (kind === "diffsOutOfDate") {
    return {
      background: theme.colors.warningBackground,
      border: theme.colors.warning,
      color: theme.colors.warning,
      icon: <MdOutlineWarningAmber size={20} />,
    };
  }

  return {
    background: theme.colors.dangerBackground,
    border: theme.colors.danger,
    color: theme.colors.danger,
    icon: <MdErrorOutline size={20} />,
  };
};
